module.exports = __webpack_public_path__ + "media/images/flags/64/Greenland-3cd60b614685af20dc72b1debbdd50f1.png";